// areaOpsBatchLabel — constants + history label for batch area ops ("Toplu
// Alan İşlemleri": several staged region edits sent as ONE area-ops-batch job).
//
// LEAF module — keep it import-free. ImageAnimatorModal imports it for its
// version rail, and areaOpsSubmit.js already imports ImageAnimatorModal, so any
// import here that reaches areaOpsSubmit would close a cycle.

// Backend metadata.operation of a batch row == the batch pin's featureId.
export const AREA_OPS_BATCH_OPERATION = "area-ops-batch";
export const MAX_BATCH_OPS = 8;

const defaultT = (_key, o) => o.defaultValue;

// History label of a batch version: just "Toplu Düzenleme" (an op count did
// not fit the row).
export function formatAreaOpsBatchLabel(t = defaultT) {
  return t("AreaOps.BatchLabel", { defaultValue: "Toplu Düzenleme" });
}
